import React, { useCallback } from "react";
import PropTypes from "prop-types";
import Select from "shared/components/oknf/OkSelect";
import { isOnlyDigitsOrEmpty, DIALING_CODE_SELECT_OPTIONS } from "./helpers";
import OkInput from "shared/components/oknf/OkInput";
import { isAndroid } from "shared/util/EnvironmentHelpers";

import "./PhoneInput.scss";

const formatActiveValue = (({ dialingCode }) => dialingCode && `+${dialingCode}`);

const deviceSepcificPhoneProps = {};

// turn off autocmplete for android to fix phone numbers being entered backwards
if (isAndroid) {
	deviceSepcificPhoneProps.autoComplete = "off";
} else {
	// tel-national is the entire phone number without the country code component
	deviceSepcificPhoneProps.autoComplete = "tel-national";
}

const PhoneInput = ({
	dialingCode, updateDialingCode,
	isoCode, updateIsoCode,
	phoneNumber, updatePhoneNumber,
}) => {
	// value is formatted as `country_dialing code`
	// becuase some countries have the same dialing code e.g. US, CN
	const countryAndDialingCode = `${isoCode}_${dialingCode}`;

	const _handlePhoneNumberChange = useCallback((e) => {
		const value = e.target.value;

		if (!isOnlyDigitsOrEmpty(value) || value.length > 15) {
			return;
		}

		updatePhoneNumber(value);
	}, [updatePhoneNumber]);

	const _handlePhonePaste = useCallback((e) => {
		e.preventDefault();
		let pasted;

		try {
			pasted = (e.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "");
		} catch (err) {
			pasted = "";
		}

		if (!isOnlyDigitsOrEmpty(pasted) || pasted.length > 15) {
			return;
		}

		updatePhoneNumber(pasted);
	}, [updatePhoneNumber]);

	const _handleDialingCodeChange = useCallback((e) => {
		const value = e.target.value;
		const [countryCode, updatedDialingCode] = value.split("_");

		updateDialingCode(updatedDialingCode);
		updateIsoCode(countryCode);
	}, [updateDialingCode, updateIsoCode]);

	return (
		<div className="phone-input oknf oknf--gray">
			<Select
				value={countryAndDialingCode}
				name="country-code"
				options={DIALING_CODE_SELECT_OPTIONS}
				onChange={_handleDialingCodeChange}
				formatActiveValue={formatActiveValue}
			/>
			<OkInput
				type="tel"
				name="phone-number"
				maxLength={15}
				required
				aria-required
				value={phoneNumber}
				onChange={_handlePhoneNumberChange}
				onPaste={_handlePhonePaste}
				{...deviceSepcificPhoneProps}
			/>
		</div>
	);
};

PhoneInput.propTypes = {
	dialingCode: PropTypes.string.isRequired,
	updateDialingCode: PropTypes.func.isRequired,
	isoCode: PropTypes.string.isRequired,
	updateIsoCode: PropTypes.func.isRequired,
	phoneNumber: PropTypes.string.isRequired,
	updatePhoneNumber: PropTypes.func.isRequired,
};

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/shared/components/PhoneInput/index.jsx